module.exports = __webpack_public_path__ + "static/img/jump.f9a292de.webp";